import { useContext } from "react";
import { Box } from "@mui/material";
import { LanguageContext } from "../../../../context/LanguageContext";
import { ReactComponent as DiscountIcon } from "../../../../assets/icons/discount.svg";
import { ParagraphText } from "../../../../Libraries";
import { formatNum } from "../../../../oscar-pos-core/constants";
import styles from "./styles.module.css";

const SummaryList = ({ itemList }) => {
  const [I18n] = useContext(LanguageContext);
  return (
    <Box
      className={styles.tableBodyBox}
      role="table"
      aria-label={I18n.order_summary}
    >      
      {itemList.map((item) => (
        <Box key={item?.id} className={styles.BodyRow} role="row">
          <Box
            component="div"
            role="cell"
            className={`${styles.thCell}`}
          >
            <ParagraphText className="fontSize14 fontWeight400 newFontColor truncate">
              {item?.name}
            </ParagraphText>
          </Box>
          <Box
            component="div"
            role="cell"
            className={styles.thCell}
          >
            <ParagraphText className="fontSize14 fontWeight400 newFontColor truncate">
              x{item?.quantity}
            </ParagraphText>
          </Box>
          <Box
            component="div"
            role="cell"
            className={styles.thCell}
          >
            <ParagraphText
              variant="body1"
              className={`truncate ${styles.amountColumn}`}
            >
              <span>
                Rs. {formatNum(item?.selling_price)}
              </span>
              {item?.discount ? (
                <span
                  variant="body1"
                  color={"#8993A0"}
                  className="fontSize12 fontWeight400 newLightColor truncate"
                >
                  <span component="span" className={styles.discountIcon}>
                    <DiscountIcon />
                  </span>
                  Rs.{" "}
                  {item?.discount_method === "%"
                    ? formatNum(
                        (item?.discount * item?.selling_price) / 100
                      )
                    : formatNum(item?.discount)}
                </span>
              ) : (
                ""
              )}
            </ParagraphText>
          </Box>
        </Box>
      ))}
    </Box>
  );
};

export default SummaryList;
